import { render, staticRenderFns } from "./Departmental.vue?vue&type=template&id=1c939e26"
import script from "./Departmental.vue?vue&type=script&lang=js"
export * from "./Departmental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports